import React from 'react';
import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { DragOutlined, DeleteOutlined } from '@ant-design/icons';
import BorderlessButton from '../../../common/buttons/BorderlessButton';

function DropdownOptionCard({ id, index, name, onDelete }) {
  return (
    <Draggable draggableId={id.toString()} index={index}>
      {({ innerRef, draggableProps, dragHandleProps }) => (
        <div
          ref={innerRef}
          {...draggableProps}
          className="boards-status-card"
          style={{
            ...draggableProps.style,
          }}
        >
          <Row justify="space-between" align="middle">
            <Col flex="18px">
              <Row
                justify="center"
                align="middle"
                style={{ height: '100%', paddingRight: 5 }}
              >
                <DragOutlined
                  {...dragHandleProps}
                  className="boards-status-dragger"
                />
              </Row>
            </Col>

            <Col flex="auto">
              <div style={{ marginLeft: 5 }}>
                <Typography.Text>{name}</Typography.Text>
              </div>
            </Col>

            <Col flex="30px">
              <BorderlessButton
                iconNode={
                  <DeleteOutlined style={{ margin: 0, color: 'red' }} />
                }
                onClick={() => onDelete(id)}
              />
            </Col>
          </Row>
        </div>
      )}
    </Draggable>
  );
}

DropdownOptionCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DropdownOptionCard;
